module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        link(scope, element, iAttrs, controller, transcludeFn) {
            transcludeFn(function (clone) {
                element.append(clone);
            });

            element.find('label').addClass('olySelect-label');
            element.find('select').addClass('olySelect-select');
        },
        template: '<i class="olySelect-icon icon-chevron_down"></i>'
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/select/select-directive.js
 **/